import React, { useState, useEffect } from "react";
import "../../styles/CommonForms.css";
import FormPageData from "../../data/Manitoba/formPageData.js";
import FormPage from "../../components/FormPage.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import ListSubheader from "@mui/material/ListSubheader";
import formsList from "../../data/Manitoba/formsList.js";

export default function CommonForms({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });
  const [FormType, setFormType] = useState("");

  const handleFormType = (e) => {
    setFormType(e.target.value);
  };

  const scrollTop = (e) => {
    window.scrollTo(0, 0);
  };

  let currentPageData = FormPageData.filter((item) => item.form === FormType);

  const ITEM_HEIGHT = 100;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
        width: 360,
        borderRadius: 10,
      },
    },
  };

  useEffect(() => {
    setProvince("MB");
  });

  return (
    <div className="w-full  flex flex-col justify-center items-center">
      <div className="flex  ">
        <ThemeProvider theme={theme}>
          <FormControl
            sx={{
              mt: 5,
              mb: 5,
              minWidth: 370,
              maxWidth: 370,
            }}
          >
            <InputLabel size="small" className="select-default-label">
              Form Type
            </InputLabel>
            <Select
              value={FormType}
              name="Form Type"
              label="Form Type"
              onChange={handleFormType}
              size="small"
              MenuProps={MenuProps}
              sx={{ borderRadius: 20 }}
            >
              {formsList.map((item, index) =>
                item.type === "section" ? (
                  <ListSubheader
                    key={`section-${item.title}-${index}`}
                    disableSticky
                    sx={{
                      mt: 1,
                      mb: -2,
                      fontWeight: 600,
                      fontSize: "1rem",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {item.title}
                  </ListSubheader>
                ) : (
                  <MenuItem
                    key={`form-${item.formNumber}-${index}`}
                    value={item.formNumber}
                    style={{ whiteSpace: "normal" }}
                  >
                    {item.title}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
        </ThemeProvider>
      </div>
      <div className="max-w-3xl w-full flex justify-left">
        {currentPageData.length > 0 ? (
          <>
            <div
              className="mb-3"
              dangerouslySetInnerHTML={{
                __html: currentPageData[0].description,
              }}
            />
          </>
        ) : (
          ""
        )}
      </div>
      {FormType === "" ? (
        <div className="max-w-3xl w-full flex justify-left">
          <p>
            <strong>Disclaimer:</strong>
            <br />
            Since every deal is unique, the forms displayed within this section
            are for educational purposes only and are not to be relied upon as
            an all inclusive source of information. They are prepared to provide
            a general understanding of how to fill out the forms in common
            scenarios. Depending on your specific transaction, you may require
            legal, accounting or other professional advice, as the descriptions
            and tips on each form do not cover all circumstances.
          </p>
        </div>
      ) : (
        ""
      )}
      {currentPageData.map((item) => (
        <FormPage key={Math.random()} PageData={item} />
      ))}
      {FormType === "" ? (
        ""
      ) : (
        <div className="back-to-top" onClick={scrollTop}>
          Back To Top
        </div>
      )}
    </div>
  );
}
